module.exports = __webpack_public_path__ + "img/5ddc389.jpg";